import { InputSelectOption } from "../types/Input-select-option";

/**
 * Static factory class to create strongly typed dropdown option arrays.
 *
 * Provides a generic interface for mapping data models into EzGridDropdownOptions.
 */
export class DropdownOptionBuilder {
  /**
   * Converts an array of items into EzGridDropdownOptions using value and label selectors.
   *
   * @template T - The type of items in the input array.
   * @param items - The input array of items to be transformed.
   * @param getValue - A function to extract the value for each option.
   * @param getLabel - A function to extract the display label for each option.
   * @returns An array of EzGridDropdownOptions.
   */
  static createOptions<T>(
    items: T[],
    getValue: (item: T) => string | number,
    getLabel: (item: T) => string
  ): InputSelectOption[] {
    return items.map(item => ({
      ...item, // <-- copy all properties, including parentValue
      value: getValue(item),
      viewValue: getLabel(item)
    }));
  }
}
